<template>
  <v-container>
    <v-btn
      v-if="isValidToken == true"
      class="m-5"
      color="primary"
      @click="generatePdf"
      >Télécharger / Download
    </v-btn>

    <v-container
      v-if="isValidToken == true"
      id="receptHtml"
      style="max-width: 800px"
      ref="receptHtml"
      fluid
      fill-height
    >
      <v-layout align-center justify-center>
        <div class="navbar-toggler body"></div>
        <v-flex>
          <v-row>
            <v-col cols="12">
                <v-row>
                  <v-col cols="2" md="2">
                    <img id="img-flag" v-bind:src="flag"
                  /></v-col>
                  <v-col class="text-center" cols="8"><h4>Cameroun</h4> </v-col>
                  <v-col cols="2" md="2">
                    <img id="img-logo" v-bind:src="logo" />
                  </v-col>
                </v-row>
                <v-col class="text-center" cols="12" md="12">
                  <h5>Formulaire de demande de visa/ Visa Request Visa</h5>
                </v-col>

                <v-row>
                  <v-col class="text-center" cols="9" md="9">
                    <span class="h4">Code: {{ codeDemnde }}</span>
                  </v-col>

                  <v-col class="text-right" cols="3" md="3">
                    <qr-code
                      :text="JSON.stringify(full_url)"
                      :size="90"
                    ></qr-code>
                  </v-col>
                </v-row>

             
                <v-row cols="12" justify="space-around">
                  <v-col class="text-left" cols="12" md="12">
                    <h4>Information personnelles / Identity of applicant</h4>

                    <span class="h6_span"> Nom/Name: {{ demand.nom }} </span>
                    <br />
                    <span class="h6_span">
                      Prénom/ Given Name: {{ demand.prenom }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Pays de naissance/Birth Country:
                      {{ demand.birth_country }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Date de naissance/Date of birth:
                      {{ format_date(demand.birthday, "L") }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Lieu de naissance / Place of birth:
                      {{ demand.birth_place }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Nationalité actuelle: {{ demand.now_nationality }}
                    </span>

                    <br />
                    <span class="h6_span">
                      Nationalité d'origine:
                      {{ demand.origine_nationality }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Etat civil / Civility:
                      {{ demand.civility }}
                    </span>
                    <br />
                  </v-col>

                  <v-col style="" class="text-left" cols="12" md="12">
                    <h4>
                      Informations additionnelles / additionals informations
                    </h4>

                    <span class="h6_span">
                      Adresse géographique /Adresse: {{ demand.adresse_geo }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Code postal / Postal code:
                      {{ demand.code_postal }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Ville/ town: {{ demand.ville }}
                    </span>
                    <br />
                    <span class="h6_span"> Email: {{ demand.email }} </span>
                    <br />
                    <span class="h6_span">
                      Numéro de télphone / Phone Number:
                      {{ demand.telephone }}
                    </span>
                    <br />
                    <span class="h6_span">
                      Profession / Work:
                      {{ demand.profession }}
                    </span>
                    <br />
                  </v-col>
                </v-row> 
              </v-col>
            
            <br/>
            <br/><br/>
            <br/><br/>
            <br/>
            <v-col style="" class="text-left" cols="12" md="12">
              <h4>Informations du voyage / travel informations</h4>

              <span class="h6_span">
                Numéro du passport /Passpsort number:
                {{ demand.numpasseport }}
              </span>
              <br />
              <span class="h6_span">
                Pays de délivrance/Deliver country:
                {{ demand.pays_delivrance }}
              </span>
              <br />
              <span class="h6_span">
                Date délivrance/Deliver date:
                {{ format_date(demand.date_delivrance_passeport, "L") }}
              </span>
              <br />
              <span class="h6_span">
                Date d'expiration/ Expiration date:
                {{ format_date(demand.dateexpirationpasseport, "L") }}
              </span>
              <br />
              <span class="h6_span">
                Lieu d'obtention du visa / Visa obtain country:
                {{ demand.pays_origine }}
              </span>
              <br />
              <span class="h6_span">
                Motif du voyage / Travel raison:
                {{ demand.type_visas }}
              </span>
              <br />

              <span class="h6_span">
                Date de depart / Departure date:
                {{ format_date(demand.date_depart, "L") }}
              </span>
              <br />
              <span class="h6_span">
                Date de retour / Return date:
                {{ format_date(demand.date_retour, "L") }}
              </span>
              <br />
            </v-col>
            <br /><br />
            <v-col
              v-if="demand.nom_contact_cam != null"
              class="text-left"
              cols="12"
              md="12"
            >
              <h4>Contact d'affaire / Your business contacts</h4>

              <span class="h6_span">
                Nom de votre contact/Contact Name: {{ demand.nom_contact_cam }}
              </span>
              <br />
              <span class="h6_span">
                Adresse de votre contact /Contact Adresse:
                {{ demand.adrese_contact_cam }}
              </span>
              <br />
              <span class="h6_span">
                Téléphone de votre contact / Contact phone:
                {{ demand.telephone_contact_cam }}
              </span>
              <br />
              <span class="h6_span">
                Email de votre contact / Contact Email:{{
                  demand.email_contact_cam
                }}
              </span>
              <br />
              <span class="h6_span">
                Ville de votre contact / Contact town:{{
                  demand.ville_contact_cam
                }}
              </span>
            </v-col>

            <v-col
              v-if="demand.nom_famille_cam != null"
              class="text-left"
              cols="12"
              md="12"
            >
              <h4>Famille au Cameroun/ Your Cameroun familly identity</h4>

              <span class="h6_span">
                Nom de la famille/Familly Name: {{ demand.nom_famille_cam }}
              </span>
              <br />
              <span class="h6_span">
                Adresse de la famille /Familly Adresse:
                {{ demand.adrese_famille_cam }}
              </span>
              <br />
              <span class="h6_span">
                Téléphone de la famille / Familly phone:
                {{ demand.telephone_famille_cam }}
              </span>
              <br />
              <span class="h6_span">
                Email de la famille / Familly Email:{{
                  demand.email_famille_cam
                }}
              </span>
              <br />
              <span class="h6_span">
                Ville de la famille / Familly town:{{
                  demand.ville_famille_cam
                }}
              </span>
            </v-col>

            <v-col class="text-left mt-5" cols="12" md="12">
              <h4>
                Residence au Cameroun/ Your Cameroun residence information
              </h4>

              <span class="h6_span">
                Nom de la residence/Residence Name:
                {{ demand.nom_residence_cam }}
              </span>
              <br />
              <span class="h6_span">
                Adresse de la residence /Residence Adresse:
                {{ demand.adrese_residence_cam }}
              </span>
              <br />
              <span class="h6_span">
                Téléphone de la residence / Residence phone:
                {{ demand.telephone_residence_cam }}
              </span>
              <br />
              <span class="h6_span">
                Email de la residence / Residence Email:{{
                  demand.email_residence_cam
                }}
              </span>
              <br />
              <span class="h6_span">
                Ville de la residence / Residence town:{{
                  demand.ville_residence_cam
                }}
              </span>
            </v-col>

            <v-col class="text-right mb-3" cols="12"
              ><span class="h6_span">
                Fait le {{ format_date(demand.updated_at, "L LTS") }}
                <br />
              </span>
            </v-col>
            <v-col class="text-right mt-5" cols="12">
              <span class="h6_span">{{
                demand.nom + " " + demand.prenom
              }}</span>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="isValidToken == false" fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex>
          <v-row class="text-center">
            <v-card width="500" class="mx-auto" style="border: solid 2px gray">
              <v-card-text>
                <div
                  style="
                    font-weight: 800;
                    color: red !important;
                    margin-top: 100px;
                    margin-bottom: 50px;
                  "
                >
                  <h4 style="font-weight: 800; color: red" class="mx-auto">
                    Token invalid !
                  </h4>
                </div>
                <div
                  style="
                    margin-top: 50px;
                    margin-bottom: 50px;
                    font-weight: 800;
                  "
                >
                  <v-icon color="red" size="100px"> mdi-emoticon-sad </v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
import flag from "../../public/cam_flag.png";
import logo from "../../public/flag_logo1.png";
import html2pdf from "html2pdf.js";
import VueQRCodeComponent from "vue-qrcode-component";
import { mapGetters } from "vuex";

export default {
  name: "RegisterRecept",

  components: {
    "qr-code": VueQRCodeComponent,
  },
  props: {},
  data() {
    return {
      isValidToken: null,
      demand: null,
      flag: flag,
      logo: logo,
      token: null,
      full_url: null,
      codeDemnde: null,
      languages: [
        { id: 0, name: "fr", flag: "fr", langue: "Français" },
        { id: 1, name: "en", flag: "us", langue: "English" },
      ],
      courseId: null,
    };
  },

  created() {
    this.token = this.$route.params.id;
    this.full_url = window.location.href;
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    moment.locale(this.langLocal);
  },
  mounted() {
    this.initialize();
  },
  computed: {
    ...mapGetters(["authenticated", "langLocal", "isdark"]),
  },
  methods: {
    format_date(value, format) {
      if (value) {
        return moment(String(value)).format(format);
      }
    },

    changeLanguage(id) {
      this.$store.dispatch("setlanguage", this.languages[id]["name"]);
    },

    //jspdf does not include the bootstrap style layout
    generatePdf() {
      var element = this.$refs.receptHtml;
      var opt = {
        margin: 0.1,
        filename: "RegisterRecept_" + this.codeDemnde + ".pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(opt).save();
    },

    async initialize() {
      const formdata = new FormData();
      formdata.append("token", this.token);
      await this.$store
        .dispatch("getDemandFormular", formdata)
        .then((response) => {
          if (response.success && response.data.id) {
            this.demand = response.data;
            this.codeDemnde = this.demand.code_demande;
            this.isValidToken = true;
            this.generatePdf();
          } else {
            this.isValidToken = false;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.h6_span {
  font-weight: 400 !important;
  font-family: "Lato", Arial, sans-serif !important;
  color: #000 !important;
  font-size: 0.75em !important;
}

#receptHtml {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;

  padding: 30px;
  border-style: solid;
  border-color: black;
}
.light-text {
  font-size: 16px;
  font-weight: 100;
}
#site-header {
  margin-bottom: 100px;
}
#fixed-header {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.no-space {
  padding: 0px !important;
  margin: 0px !important;
}
.div-lang {
  background-color: rgb(37, 51, 114);
  height: 50px;
  padding: 0px;
}

.divider {
  border-color: white !important;
}
#qr-code {
  margin: auto !important;
  width: fit-content;
}
.red-texte {
  color: red;
}
#img-logo {
  width: 120px;
  height: 80px;
  border-radius: 3px;
}
#img-flag {
  width: 120px;
  height: 80px;
  border-radius: 3px;
}
@media (max-width: 990px) {
  #img-logo {
    width: 50px;
    height: 50px;
  }
  #img-flag {
    width: 50px;
    height: 50px;
  }
}
</style>
